import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Switch from "react-switch";
import { Eye, EyeOff } from "lucide-react"; // Icônes pour afficher/masquer
import { Editor } from "@tinymce/tinymce-react";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Button,
  Tooltip,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";

function NewMessage() {
  const editorRef = useRef(null);

  const [wait, setWait] = useState(1000);
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "transparent", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [configData, setConfigData] = useState([]);
  //meta title
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleOffcanvasToggle = () => {
    setShowOffcanvas(!showOffcanvas);
    document.body.classList.toggle("offcanvas-open");
  };
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const [messageContent, setMessageContent] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showClientSecret, setShowClientSecret] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };
  // Variable
  const [formData, setFormData] = useState({
    "Nom de l'action": "",
    Sujet: "",
    Actif: {
      label: "Oui",
      value: 1,
    },
    "Balises non nulles": "",

    Message: "",
    "Pièce jointe": {
      label: "Non",
      value: 0,
    },
    "CGP en copie": {
      label: "Non",
      value: 0,
    },
    Publipostage: {
      label: null,
      value: null,
    },
    "Statut de réservation": {
      label: null,
      value: null,
    },
    "Mode de règlement": {
      label: null,
      value: null,
    },
    "Statut de signature": {
      label: null,
      value: null,
    },
    "Compte de messagerie": {
      label: null,
      value: null,
    },
  });

  // Fonction pour gérer les changements de valeurs
  const handleInputChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  /*************************   Publipostages  *******************************/
  const [Publipostage, setPublipostageData] = useState({ data: [] });

  const getPublipostage = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/messages/publipostages`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((Publipostage) => {
          setPublipostageData(Publipostage);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPublipostageOptions = () => {
    return [
      {
        options: Publipostage.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   StatutsReservations  *******************************/
  const [StatutsReservations, setStatutsReservationsData] = useState({
    data: [],
  });

  const getStatutsReservations = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/messages/statuts_reservations`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((StatutsReservations) => {
          setStatutsReservationsData(StatutsReservations);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutsReservationsOptions = () => {
    return [
      {
        options: StatutsReservations.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   ModeReglement  *******************************/
  const [ModeReglement, setModeReglementData] = useState({ data: [] });

  const getModeReglement = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/messages/mode_reglements`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((ModeReglement) => {
          setModeReglementData(ModeReglement);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderModeReglementOptions = () => {
    return [
      {
        options: ModeReglement.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   SmtpParametres  *******************************/
  const [SmtpParametres, setSmtpParametresData] = useState({ data: [] });

  const getSmtpParametres = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/messages/smtp_parametres`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((SmtpParametres) => {
          setSmtpParametresData(SmtpParametres);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderSmtpParametresOptions = () => {
    return [
      {
        options: SmtpParametres.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   StatutsSignature  *******************************/
  const [StatutsSignature, setStatutsSignatureData] = useState({ data: [] });

  const getStatutsSignature = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/messages/statuts_signatures`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((StatutsSignature) => {
          setStatutsSignatureData(StatutsSignature);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutsSignatureOptions = () => {
    return [
      {
        options: StatutsSignature.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  ///
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Non
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Oui
      </div>
    );
  };
  ///
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      setLoading(true);

      const response = await fetch(`https://www.fluxod.com/${api}/messages/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          nom_action: formData["Nom de l'action"],
          sujet: formData.Sujet,
          message: messageContent,
          pj: formData["Pièce jointe"]?.value == 1 ? 1 : 2,
          cgp_copie: formData["CGP en copie"]?.value == 1 ? 1 : 2,
          publipostage_id:
            formData["Pièce jointe"]?.value == 1
              ? formData.Publipostage?.value
              : null,
          actif: formData["Actif"]?.value || "",
          smtp_parametre_id: formData["Compte de messagerie"]?.value || "",
          statuts_reservation_id:
            formData["Statut de réservation"]?.value || "",
          mode_reglement_id: formData["Mode de règlement"]?.value || "",
          statuts_signature: formData["Statut de signature"]?.value || "",
          balises_non_nulles: formData["Balises non nulles"],
        }),
      });

      if (response.ok) {
        console.log("PATCH request successful");
        handleNavigate();
      } else {
        console.error("PATCH request failed");
        const responseData = await response.json();

        if (responseData && responseData.message_validation) {
          // Si le champ "contact_validation" est présent dans la réponse JSON
          const errors = responseData?.message_validation;

          errors.forEach((error) => {
            toast.error(error);
          });
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
  };
  /******************************* END Validation *******************************************/
  const [listeData, setListeData] = useState("");

  const getListe = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/messages/list_tags?publipostage_id=${
          formData.Publipostage?.value || ""
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setListeData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getPublipostage();
    getStatutsReservations();
    getModeReglement();
    getSmtpParametres();
    getStatutsSignature();
  }, []);
  useEffect(() => {
    getListe();
  }, [formData.Publipostage]);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Messages | New";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails Message
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Offcanvas
              isOpen={showOffcanvas}
              scrollable
              backdrop={false}
              toggle={handleOffcanvasToggle}
              style={{ width: "35%" }}
            >
              <OffcanvasHeader toggle={handleOffcanvasToggle}>
                Liste des balises
              </OffcanvasHeader>
              <OffcanvasBody>
                <div dangerouslySetInnerHTML={{ __html: listeData.message }} />
              </OffcanvasBody>
            </Offcanvas>
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/messages/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Messages
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          configData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="12">
                                <Col>
                                  {formData ? (
                                    <Row>
                                      <Card className="mb-4">
                                        <CardTitle tag="h5">
                                          Identification
                                        </CardTitle>
                                        <CardBody>
                                          <Row className="mb-3">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    paddingTop: "10px",
                                                    color: "#7f7f7f",
                                                    whiteSpace: "wrap",
                                                  }}
                                                >
                                                  Liste des balises disponibles
                                                  :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="pt-2 col-8">
                                              <Button
                                                onClick={handleOffcanvasToggle}
                                              >
                                                Liste
                                              </Button>
                                            </Col>
                                          </Row>
                                          {Object.keys(formData).map((key) => {
                                            if (
                                              key === "Publipostage" &&
                                              formData["Pièce jointe"]
                                                ?.value !== 1
                                            ) {
                                              return null;
                                            }

                                            return (
                                              <Row key={key} className="mb-3">
                                                <Col
                                                  className="col-4"
                                                  style={colStyle}
                                                >
                                                  <i>
                                                    <span>
                                                      {key ==
                                                      "Balises non nulles" ? (
                                                        <>
                                                          {key}{" "}
                                                          <i
                                                            className="bx bx-info-circle"
                                                            style={{
                                                              marginLeft: "5px",
                                                              cursor: "pointer",
                                                              color: "black",
                                                              fontSize: "15px",
                                                            }}
                                                            id="balisenonnulles"
                                                            onMouseEnter={
                                                              toggleTooltip
                                                            }
                                                            onMouseLeave={
                                                              toggleTooltip
                                                            }
                                                          />
                                                          <Tooltip
                                                            placement="top"
                                                            isOpen={tooltipOpen}
                                                            target="balisenonnulles"
                                                            toggle={
                                                              toggleTooltip
                                                            }
                                                          >
                                                            Saisir ici les
                                                            balises séparées par
                                                            des virgules qui, si
                                                            elles sont vides, ne
                                                            déclencheront pas
                                                            l'envoi du message.
                                                          </Tooltip>{" "}
                                                        </>
                                                      ) : (
                                                        key
                                                      )}{" "}
                                                      :
                                                    </span>
                                                  </i>
                                                </Col>
                                                <Col className="col-8">
                                                  {key === "Message" ? (
                                                    <Editor
                                                      apiKey="qtpzuvciq1zhh5k87yw2b2hoie40flpoqkafr142u8lfhp6i"
                                                      onInit={(evt, editor) =>
                                                        (editorRef.current =
                                                          editor)
                                                      }
                                                      onEditorChange={(
                                                        content
                                                      ) => {
                                                        setMessageContent(
                                                          content
                                                        );
                                                      }}
                                                      initialValue={
                                                        formData["Message"]
                                                      }
                                                      init={{
                                                        height: 500,
                                                        menubar: true,
                                                        plugins: [
                                                          "advlist",
                                                          "autolink",
                                                          "lists",
                                                          "link",
                                                          "image",
                                                          "charmap",
                                                          "preview",
                                                          "anchor",
                                                          "searchreplace",
                                                          "visualblocks",
                                                          "code",
                                                          "fullscreen",
                                                          "insertdatetime",
                                                          "media",
                                                          "table",
                                                          "code",
                                                          "help",
                                                          "wordcount",
                                                          "autosave",
                                                        ],
                                                        toolbar:
                                                          "undo redo | blocks | " +
                                                          "bold italic forecolor | alignleft aligncenter " +
                                                          "alignright alignjustify | bullist numlist outdent indent | " +
                                                          "removeformat | help",
                                                        content_style:
                                                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                                      }}
                                                    />
                                                  ) : key === "Publipostage" ? (
                                                    <Select
                                                      value={formData[key]}
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          key,
                                                          e
                                                        )
                                                      }
                                                      options={renderPublipostageOptions()}
                                                      isClearable={true}
                                                      className="select2"
                                                    />
                                                  ) : key ===
                                                    "Statut de réservation" ? (
                                                    <Select
                                                      value={formData[key]}
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          key,
                                                          e
                                                        )
                                                      }
                                                      options={renderStatutsReservationsOptions()}
                                                      isClearable={true}
                                                      className="select2"
                                                      styles={styles(false)}
                                                    />
                                                  ) : key ===
                                                    "Mode de règlement" ? (
                                                    <Select
                                                      value={formData[key]}
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          key,
                                                          e
                                                        )
                                                      }
                                                      options={renderModeReglementOptions()}
                                                      isClearable={true}
                                                      className="select2"
                                                      styles={styles(false)}
                                                    />
                                                  ) : key ===
                                                    "Compte de messagerie" ? (
                                                    <Select
                                                      value={formData[key]}
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          key,
                                                          e
                                                        )
                                                      }
                                                      options={renderSmtpParametresOptions()}
                                                      isClearable={true}
                                                      className="select2"
                                                      styles={styles(false)}
                                                    />
                                                  ) : key ===
                                                    "Statut de signature" ? (
                                                    <Select
                                                      value={formData[key]}
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          key,
                                                          e
                                                        )
                                                      }
                                                      options={renderStatutsSignatureOptions()}
                                                      isClearable={true}
                                                      className="select2"
                                                      styles={styles(false)}
                                                    />
                                                  ) : typeof formData[key] ===
                                                    "object" ? (
                                                    <Switch
                                                      uncheckedIcon={
                                                        <Offsymbol />
                                                      }
                                                      checkedIcon={<OnSymbol />}
                                                      onColor="#555B21"
                                                      onChange={() => {
                                                        handleInputChange(key, {
                                                          label:
                                                            formData[key]
                                                              .value === 1
                                                              ? "Non"
                                                              : "Oui",
                                                          value:
                                                            formData[key]
                                                              .value === 1
                                                              ? 2
                                                              : 1,
                                                        });
                                                      }}
                                                      checked={
                                                        formData[key].value ===
                                                        1
                                                      }
                                                    />
                                                  ) : key ==
                                                    "Balises non nulles" ? (
                                                    <textarea
                                                      type="text"
                                                      className="form-control form-control-sm"
                                                      value={formData[key]}
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          key,
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  ) : (
                                                    <input
                                                      type="text"
                                                      className="form-control form-control-sm"
                                                      value={formData[key]}
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          key,
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  )}
                                                </Col>
                                              </Row>
                                            );
                                          })}
                                        </CardBody>
                                      </Card>
                                    </Row>
                                  ) : null}
                                </Col>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} setWait={wait} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default NewMessage;
